import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useGetPortalProjectQuery } from '../../redux/api/compassPortal';
import { useGetUserTypeQuery } from '../../redux/api/user';
import CompassAgentChat from './CompassAgentChat';

// CHA-352 (EPIC G): the SIMPLE project view is now just the AI data agent —
// upload your data and chat with it through to a first model. Nothing else on
// the page: one chat surface, no duplicate wizard. The full internal view
// (ProjectHome / stage pages) is untouched.

const SimpleProjectPage = () => {
    const { projectId } = useParams();
    const navigate = useNavigate();
    const { data: project, isLoading } = useGetPortalProjectQuery({ projectId });
    const { data: userType } = useGetUserTypeQuery();

    if (isLoading) {
        return <div style={{ width: '100%', textAlign: 'center', padding: '80px 0' }}><Spin size="large" /></div>;
    }
    // Query settled but no project (bad/unknown id, 404, or no access): show a
    // clear message + way back, instead of an eternal spinner.
    if (!project) {
        return (
            <div style={{ width: '100%', maxWidth: 760, margin: '0 auto', padding: '80px 0', textAlign: 'center' }}>
                <h2>Project not found</h2>
                <p style={{ color: '#888' }}>This project doesn't exist or you don't have access to it.</p>
                <Button type="primary" onClick={() => navigate('/compass-portal')}>Back to projects</Button>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', maxWidth: 760, margin: '0 auto' }}>
            <button
                className="cp-back-link"
                onClick={() => navigate(userType === 'Client' ? '/compass-portal' : `/compass-portal/${projectId}`)}
            >
                <ArrowLeftOutlined /> {userType === 'Client' ? 'Back to projects' : 'Full view'}
            </button>

            <h2 style={{ marginTop: 4 }}>{project.project_name}</h2>

            <CompassAgentChat projectId={projectId} />
        </div>
    );
};

export default SimpleProjectPage;
